import * as React from 'react';
import ReactToggle from 'react-toggle';

import 'react-toggle/style.css';
import './style.scss';

export interface IToggleProps {
  bsStyle: string;
  onToggle: TButtonOnClick;
  disabled?: boolean;
  toggleState: boolean;
  children?: any;
  inverted?: boolean;
  id?: string;
}

let toggleIdCounter = 0;

export default class Toggle extends React.Component<IToggleProps, {}> {
  private toggleId: string;

  constructor(props: IToggleProps) {
    super(props);
    this.toggleId = props.id || `toggle-${++toggleIdCounter}`;
  }

  render() {
    const { bsStyle, children, toggleState, inverted } = this.props;

    return children ? (
      <label htmlFor={this.toggleId} className={`toggle ${toggleState ? 'toggle--active' : ''}`}>
        <ReactToggle
          id={this.toggleId}
          className={`toggle__toggle bs-toggle ${bsStyle} ${inverted ? 'toggle__toggle__inverted' : ''}`}
          onChange={(event) => this.props.onToggle(event)}
          checked={this.props.toggleState}
          disabled={this.props.disabled}
          icons={false}
        />
        <span className="toggle__children">{children}</span>
      </label>
    ) : (
      <ReactToggle
        id={this.toggleId}
        className={`bs-toggle ${bsStyle}`}
        onChange={(event) => this.props.onToggle(event)}
        checked={this.props.toggleState}
        disabled={this.props.disabled}
        icons={false}
      />
    );
  }
}
